/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceResponseEnrollmentBlockedReason = typeof SequenceResponseEnrollmentBlockedReason[keyof typeof SequenceResponseEnrollmentBlockedReason] | null;


export const SequenceResponseEnrollmentBlockedReason = {
  mailbox_missing: 'mailbox_missing',
  mailbox_disconnected: 'mailbox_disconnected',
  mailbox_needs_reconnect: 'mailbox_needs_reconnect',
  unconfigured_steps: 'unconfigured_steps',
} as const;
